var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteRice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38B;}\n\t.st1{fill:#F3ECCF;}\n\t.st2{fill:#F9F8E2;}\n\t.st3{fill:#F6DBC0;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 104.14,
    cy: 145.4,
    rx: 32.28,
    ry: 7.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 104.14,
    cy: 141.92,
    rx: 19.37,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.03,143.29c-4.01,2.99-16.32,5.17-30.89,5.17s-26.88-2.18-30.89-5.17c-0.9,0.67-1.39,1.38-1.39,2.11 c0,4.02,14.45,7.28,32.28,7.28s32.28-3.26,32.28-7.28C136.42,144.66,135.93,143.95,135.03,143.29z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8992 -0.4375 0.4375 0.8992 -37.1191 71.9802)",
    className: "st1",
    cx: 137.67,
    cy: 116.56,
    rx: 32.28,
    ry: 7.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8992 -0.4375 0.4375 0.8992 -35.9032 70.9985)",
    className: "st2",
    cx: 136.15,
    cy: 113.43,
    rx: 19.37,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M164.53,101.14c-2.3,4.44-12.42,11.79-25.52,18.16c-13.1,6.37-25.12,9.8-30.04,8.87 c-0.51,0.99-0.64,1.84-0.32,2.51c1.76,3.61,16.18,0.22,32.21-7.58s27.6-17.05,25.84-20.67 C166.38,101.78,165.63,101.35,164.53,101.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4663 -0.8846 0.8846 0.4663 -51.8564 123.5994)",
    className: "st1",
    cx: 76.51,
    cy: 104.78,
    rx: 7.28,
    ry: 32.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4663 -0.8846 0.8846 0.4663 -48.2662 123.3919)",
    className: "st2",
    cx: 78.13,
    cy: 101.7,
    rx: 1.9,
    ry: 19.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.82,117.31c-4.95,0.77-16.85-3.04-29.74-9.83S52.32,93.02,50.17,88.5c-1.11,0.17-1.87,0.57-2.21,1.22 c-1.87,3.56,9.39,13.18,25.16,21.49s30.07,12.17,31.95,8.61C105.4,119.18,105.3,118.32,104.82,117.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9939 -0.1103 0.1103 0.9939 -8.9691 15.0652)",
    className: "st1",
    cx: 131.73,
    cy: 88.63,
    rx: 32.28,
    ry: 7.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9939 -0.1103 0.1103 0.9939 -8.59 15.0018)",
    className: "st2",
    cx: 131.35,
    cy: 85.17,
    rx: 19.37,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.2,83.12c-3.66,3.41-15.65,6.93-30.13,8.54c-14.48,1.61-26.95,0.8-31.27-1.73 c-0.82,0.76-1.23,1.52-1.14,2.25c0.44,3.99,15.16,5.64,32.88,3.67c17.72-1.97,31.72-6.8,31.28-10.79 C163.73,84.34,163.17,83.69,162.2,83.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9972 -0.0751 0.0751 0.9972 -5.01 7.4343)",
    className: "st1",
    cx: 96.36,
    cy: 70.34,
    rx: 32.28,
    ry: 7.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9972 -0.0751 0.0751 0.9972 -4.7501 7.4049)",
    className: "st2",
    cx: 96.09,
    cy: 66.87,
    rx: 19.37,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127,65.91c-3.78,3.28-15.89,6.38-30.42,7.47c-14.53,1.09-26.96-0.15-31.19-2.83 c-0.85,0.73-1.28,1.48-1.22,2.21c0.3,4.01,14.96,6.17,32.73,4.83s31.94-5.67,31.64-9.68C128.49,67.18,127.95,66.51,127,65.91z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRice);
export default __webpack_public_path__ + "static/media/White_rice.09d2e1050d949af5a6484a670e749dbc.svg";
export { ForwardRef as ReactComponent };